module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/rules-icon-1990396a3044844c0ec33eab72ad845a.png";